import { DAYS_OF_WEEK } from "@offstreetparking/domain/value";
import * as z from "zod/v4";

export const permitTimeSchema = z.object({
	selectedChoicesIds: z.array(z.number()),
	choices: z.array(
		z.object({
			parkingChoiceId: z.number(),
			locationIds: z.array(z.number()).default([]),
			permitIntervals: z.array(
				z.object({
					startDate: z.string().optional(),
					startTime: z.string().optional(),
					endDate: z.string().optional(),
					endTime: z.string().optional(),
					schedules: z
						.array(
							z.object({
								startTime: z.string(),
								endTime: z.string(),
								day: z.enum(DAYS_OF_WEEK),
							}),
						)
						.optional(),
				}),
			),
		}),
	),
});

export type PermitTimeFormData = z.infer<typeof permitTimeSchema>;
